import { BUNDLED_EXPERIENCES_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { BundledExperienceChecklistRow } from './types';

export function buildBundledExperienceQueueItem(row: BundledExperienceChecklistRow): ApprovalQueueItem {
  return {
    categoryId: BUNDLED_EXPERIENCES_CATEGORY.id,
    categoryLabel: BUNDLED_EXPERIENCES_CATEGORY.label,
    description: `${row.bundledExperience} needs bundled-experience review.`,
    details: [
      { label: 'Linked deal options', value: row.linkedDealOptions.join(', ') || 'N/A' },
      { label: 'Validity from', value: row.travelFrom || 'N/A' },
      { label: 'Validity to', value: row.travelTo || 'N/A' },
      { label: 'Blackouts', value: row.blackoutDateRange || 'None' },
      { label: 'Currency', value: row.currency || 'N/A' },
      { label: 'Children age', value: row.childAge || 'N/A' },
    ],
    id: row.id,
    title: row.bundledExperience,
  };
}

export function getBundledExperienceSearchText(row: BundledExperienceChecklistRow) {
  return [
    row.bundledExperience,
    row.linkedDealOptions.join(' '),
    row.blackoutDateRange,
    row.currency,
    row.childAge,
    row.statusLabel,
  ]
    .filter(Boolean)
    .join(' ');
}
